<script setup lang="ts">
import { features } from '../../../content'
</script>

<template>
  <section id="features" class="features">
    <div class="container">
      <div class="section-header animate animate--fade-up">
        <h2 class="section-header__title">{{ features.headline }}</h2>
        <p class="section-header__description">{{ features.lead }}</p>
      </div>

      <div class="grid grid--3">
        <div
          v-for="(feature, index) in features.items"
          :key="feature.number"
          class="feature-card animate animate--fade-up"
          :class="`animate--delay-${(index % 3) + 1}`"
        >
          <span class="feature-card__number">{{ feature.number }}</span>
          <h3 class="feature-card__title">{{ feature.title }}</h3>
          <p class="feature-card__description">{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
